import { axiosV2 } from 'interceptors/axios';
import types from 'redux/actions/actionTypes';

import { Note } from 'types';

import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

type GetNotesProps = {
  societyId?: string;
  partnerId?: string;
};

export const createNote =
  (noteData: Partial<Note>) => async (dispatch: any) => {
    try {
      const body = { ...noteData };

      const { data } = await axiosV2.post(`/notes`, body);
      const decodedData = await decryptResponse(data);

      dispatch({
        type: types.CREATE_NOTE,
        note: decodedData,
      });

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };

export const getNotes =
  ({ societyId, partnerId }: GetNotesProps) =>
  async (dispatch: any) => {
    const query = { params: { societyId, partnerId } };

    try {
      const { data } = await axiosV2.get(`/notes`, query);
      const decodedData = await decryptResponse(data);

      dispatch({
        type: types.GET_NOTES,
        notes: decodedData,
      });

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
